import loadFrontend from '@frontend';
import initClickTracking from '@frontend/click-tracking';
import initCopyrightYear from '@frontend/copyright';
import initEvents from '@frontend/events';
import initAccords from '@frontend/accordions';
import { initClickHandlers } from '@frontend/social/share-buttons';
import { cookie } from '@frontend/util/storage';
import 'bootstrap/js/dist/collapse';
import 'bootstrap/js/dist/dropdown';
import 'bootstrap/js/dist/modal';
import 'bootstrap/js/dist/tab';
import 'bootstrap/js/dist/util';
import $ from 'jquery';
import initContactUs from './contact-us';
import initKnowledge from './knowledge';
import initNavigation from './navigation';
import initSolutions from './solutions';
import initElasticSearch from './search/index';

const initFrontend = (err) => {
  if (err && err instanceof Error) {
    console.error(err);
  }
  if (!cookie.isAvailable()) {
    $('html').addClass('no-cookie');
  }
  initNavigation();
  initEvents();
  initAccords();
  initClickHandlers(); // change the way frontend default export works
  initCopyrightYear();
  initClickTracking();
  initContactUs();
  initKnowledge();
  initSolutions();
  initElasticSearch();
};

$(() => {
  loadFrontend(initFrontend);
});



// WEBPACK FOOTER //
// ./src/static/js/app.js